/** @format */

import { useContext } from "react";
import { Context } from "../stores/Provider";
import { PostMethod } from "../api/Api";
import { getSession, setSession } from "../sessionStorage/sessionStorageMethod";
import useNavigateByAgent from "./useNavigateByAgentHooks";
import { setSessionByResponse, setIsLoading } from "../function";
import { successApiResponseType } from "../@types";
import { loginResponseDataType } from "../constance/typeModel";

const useNewEntryRegisterHooks = () => {
  const { state, dispatch } = useContext(Context);
  const { navigateByAgent } = useNavigateByAgent();
  const userInfoData = getSession("user");
  const entryInfoData = getSession("entry");

  const NewEntryInfo = async () => {
    const data = {
      user_id: userInfoData.user_id,
      agent_master_id: 1, //現状、申込選択画面から新規申込を行う代理店は、おちゃのこ上位のみ
    };
    setIsLoading(true, dispatch);
    const response = await PostMethod(data, "/new_entry_info");
    return response;
  };

  const newEntryRegisterNormal = (response: successApiResponseType<loginResponseDataType>) => {
    setSessionByResponse(dispatch, state.agentPath, state.zAccount, response);
    setSession("entry_infos_count", entryInfoData.length + 1);
    return navigateByAgent("/dashboard");
  };

  const newEntryRegisterAbnormal = () => {
    return navigateByAgent("/entry_select");
  };

  return {
    NewEntryInfo,
    newEntryRegisterNormal,
    newEntryRegisterAbnormal,
  };
};

export default useNewEntryRegisterHooks;
